export default __webpack_public_path__ + "static/media/hubspot.27570630.svg";